import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const legalSections = [{
  title: 'Privacy Policy',
  content: 'We respect your privacy and are committed to protecting your personal data. We collect only the information necessary to process your order and improve your experience. We never sell or share your personal information with third parties for marketing purposes. Your payment information is processed securely through encrypted channels and is never stored on our servers.'
}, {
  title: 'Terms of Service',
  content: 'By purchasing The Backyard Pitmaster system, you agree to these terms. All digital products are delivered instantly via email. You receive a personal, non-transferable license to use the materials. Redistribution, resale, or sharing of the content is strictly prohibited. We reserve the right to update these terms at any time.'
}, {
  title: 'Disclaimer',
  content: 'This site is not a part of the Facebook website or Facebook Inc. Additionally, this site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc. Results may vary. The results described on this page are not typical. Your results will depend on your background, effort, and other factors. The information provided is for educational purposes only and does not constitute professional advice.'
}, {
  title: 'Contact',
  content: 'Have questions? Reach out to our support team at support@backyardpitmaster.com. We typically respond within 24 hours on business days. For refund requests, please email us within 14 days of your purchase with your order number.'
}];
export function StickyFooter() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <footer className="bg-[#080909] py-10 px-4 border-t border-[#1A1C1D]" data-id="element-143">
      <div className="max-w-3xl mx-auto" data-id="element-144">
        {/* Accordion Legal Sections */}
        <div className="mb-10 border border-[#1A1C1D] rounded-xl overflow-hidden" data-id="element-145">
          {legalSections.map((section, index) => <div key={index} className={index !== legalSections.length - 1 ? 'border-b border-[#1A1C1D]' : ''} data-id="element-146">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-4 md:px-6 py-4 text-smoke hover:text-ivory text-sm font-medium transition-colors" data-id="element-147">
                <span data-id="element-148">{section.title}</span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-149">
                  <ChevronDownIcon className="w-4 h-4" data-id="element-150" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-151">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} className="overflow-hidden" data-id="element-152">
                    <p className="px-6 pb-5 text-[#555] text-xs leading-relaxed" data-id="element-153">
                      {section.content}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <p className="text-smoke text-sm mb-4 text-center" data-id="element-154">
          © 2026 The Backyard Pitmaster. All Rights Reserved.
        </p>
      </div>
    </footer>;
}